import { render, staticRenderFns } from "./RelatorioExportacaoKpisSustentabilidade.vue?vue&type=template&id=57270ae9&"
import script from "./RelatorioExportacaoKpisSustentabilidade.vue?vue&type=script&lang=js&"
export * from "./RelatorioExportacaoKpisSustentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioExportacaoKpisSustentabilidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VForm,VIcon,VSpacer})
